import {Button} from "antd";
import {UploadOutlined} from "@ant-design/icons";

export function UploadButton() {
  return (
    <Button icon={<UploadOutlined/>}>
      Upload
    </Button>
  )
}